export default __webpack_public_path__ + "static/media/MEWIcon.8448f79a.svg";